import React from "react";
import type { ModelFilterComingSoonBlockConfigType } from "../../../server/AEMModelFilterSettingsTypes";
import { getAemImageUrl } from "../../../../../../common-deprecated/utils";
import { Ellipsis } from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Ellipsis";
import ImageFluid from "../../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import ButtonPrimary from "../../../../../../common-deprecated/components/aem/toyota/ButtonPrimary";
import * as Styles from "./ComingSoonBlock.styles";

const ComingSoonBlock = (props: { comingSoonBlockConfig: ModelFilterComingSoonBlockConfigType }): JSX.Element => {
    const { title, subtitle, linkLabel, linkUrl, bannerType, bannerUrl, bannerLight, bannerAltTag } =
        props.comingSoonBlockConfig;
    const isVideo = bannerType === "video";

    return (
        <Styles.Wrapper onClick={() => linkUrl && window.location.assign(linkUrl)}>
            <Styles.MediaWrapper
                showBackground={isVideo || !bannerUrl}
                lightImage={bannerLight}
                data-testid="comingsoonblock"
            >
                {bannerUrl &&
                    (isVideo ? (
                        <video autoPlay muted loop playsInline>
                            <source src={bannerUrl} type="video/mp4" />
                        </video>
                    ) : (
                        // dimensions were chosen arbitrarily based on what a 4k ultrawide and some margin
                        <ImageFluid
                            src={getAemImageUrl(bannerUrl, { fit: "wrap", wid: 1200, hei: 700, fmt: "png-alpha" })}
                            alt={bannerAltTag ?? title}
                        />
                    ))}
            </Styles.MediaWrapper>
            <Styles.Text>
                {(!!title || !!subtitle) && (
                    <>
                        {!!title && <Styles.Title lightImage={bannerLight}>{title}</Styles.Title>}
                        {!!subtitle && <Styles.Description lightImage={bannerLight}>{subtitle}</Styles.Description>}
                    </>
                )}
            </Styles.Text>
            <Styles.Actions>
                <ButtonPrimary href={linkUrl}>
                    <Ellipsis maxWidth={{ xs: "150px", xl: "none" }}>{linkLabel}</Ellipsis>
                </ButtonPrimary>
            </Styles.Actions>
        </Styles.Wrapper>
    );
};

export default ComingSoonBlock;
